export default __webpack_public_path__ + "static/media/section-icon-11.9d8a9d6b.svg";